"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandUseCase = void 0;
const phased_use_case_1 = require("../use-cases/phased-use-case");
class CommandUseCase extends phased_use_case_1.PhasedUseCase {
    async execute(input) {
        const loadResult = await this._runPhase('load', input, () => this._load(input));
        if (!loadResult.success) {
            return loadResult;
        }
        const transformResult = await this._runPhase('transform', loadResult, () => this._transform(input, loadResult.result));
        if (!transformResult.success) {
            return transformResult;
        }
        const saveResult = await this._runPhase('save', transformResult, () => this._save(loadResult.result, transformResult.result));
        if (!saveResult.success) {
            return saveResult;
        }
        const output = await this._runPhase('present', saveResult, () => this._present(input, loadResult.result, transformResult.result, saveResult.result));
        return { success: true, result: output };
    }
}
exports.CommandUseCase = CommandUseCase;
